import { Inject, Prop, Ref, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import reportRelated from '@/entities/report-insights/report-related-peoples/report-related-people.vue';
import reportReferent from '@/entities/report-insights/report-referent/report-referent.vue';
import { namespace } from 'vuex-class';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import BriefingService from '@/service/briefing.service';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { convertToBriefingResourceReq, isNullish } from '@/util/ds-util';
import { VueHtmlToPaper } from '@/entities/report-insights/printf.report';
import TopicContent from '@/entities/topic-insights/topic-content/topic-content.vue';
import { checkToShow } from '@/util/common-util';
import AskConversation from '@/v2/home/ask-goover/ask-conversation/ask-conversation.vue';
import { PAGES } from '@/shared/constants/ds-constants';
import { checkIsGuestAccount } from '@/util/guest-util';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

export const innitTopicDetails: TopicData = {
  id: '',
  coverImageUrl: '',
  topicTitle: '',
  description: '',
  topicContent: [],
  subTopics: [],
  publishedDate: '',
  languageType: '',
};

export interface TopicData {
  id: string;
  coverImageUrl: string;
  topicTitle: string;
  description: string;
  topicContent: string[];
  subTopics: ISubTopics[];
  publishedDate: string;
  languageType: string;
}

export interface ISubTopics {
  subTopicTitle: string;
  subTopicContent: string;
  subTopicDocList: ISubTopicDocList[];
}

export interface ISubTopicDocList {
  docId: string;
  docTitle: string;
  docUrl: string;
  content: string;
}

@Component({
  computed: {
    PAGES() {
      return PAGES;
    },
  },
  methods: { checkToShow },
  components: {
    vueCustomScrollbar: vueCustomScrollbar,
    'topic-content': TopicContent,
    reportReferent,
    reportRelated,
    'ask-goover': AskConversation,
  },
})
export default class myTopics extends Vue {
  scrollSettings = {
    wheelPropagation: false,
  };
  @Prop() items: any[] | [];
  @appStoreState.Getter
  public isShowDetailTopic!: boolean;
  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;
  @briefingStore.Mutation
  public updateTotalResources!: (payload: number) => void;
  @briefingStore.Mutation
  public updateAddingResources!: (payload: IResourceModel) => void;
  @appStoreState.Mutation
  public setShowDetailTopic!: (b: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailArticles!: (state?: boolean) => void;
  @briefingStore.Mutation
  public setSelectedResource!: (payload?: any) => void;

  @appStoreState.Mutation
  public setIsShowShareTopic!: (payload: boolean) => void;

  @briefingStore.Getter
  public getIsHideSelectedResourceItem!: boolean;

  @briefingStore.Mutation
  public setIsHideSelectedResourceItem!: (payload: any) => void;

  @briefingStore.Mutation
  public setReferenceDocumentsForNewBriefing!: (payload: any[]) => void;

  @appStoreState.Mutation
  public setIsCanShowCreateAgent!: (isCanShowCreateAgent: boolean) => void;

  @briefingStore.Mutation
  public setIsCreateNewBriefingFromChat!: (IsCreateNewBriefingFromChat: boolean) => void;

  @appStoreState.Mutation
  public setShowCreateBriefing!: (isShowCreateBriefing: boolean) => void;

  updatingBookmark = false;

  @Ref() contentToPrint!: HTMLDivElement;
  @Ref() imageRef!: null;
  screenWidth = window.innerWidth;
  topicDetail: any = innitTopicDetails;
  contentReference: any[] = [];
  detailSocialBP: any[] = [];
  loading = false;
  startIndex = 0;
  numberItemPerPage = 4;
  endIndex = this.startIndex + this.numberItemPerPage;
  briefingPageId = false;
  tempUserKey = JSON.parse(localStorage.getItem('localStorageUser')).id || '';
  conversationId = '';
  isShowTopicRef = true;

  @Inject('discoveryService')
  public discoveryService: () => DiscoveryAndReportService;
  @Inject('briefingService')
  private briefingService: () => BriefingService;

  mounted() {
    const hashConversation = window.location.hash;
    console.log('hashConversation', hashConversation);
    if (hashConversation.startsWith('#ask=')) {
      this.isShowTopicRef = false;
      this.conversationId = hashConversation.replace('#ask=', '');
    }
    const showReportFromS3 = this.getSelectedResource?.originParentDocDetail?.media_type || [];
    if (!isNullish(this.getSelectedResource) && this.isShowDetailTopic === true) {
      this.getDataDetail();
      // this.getRelatedPeople();
    }
    // window.addEventListener('resize', this.handleResize);
  }

  handleClosePopup() {
    this.setSelectedResource({});
    this.setShowDetailTopic(false);
  }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  // html :reference-documents="[getSelectedResource.docId, ...contentReference]"
  async getDataDetail() {
    if (!isNullish(this.getSelectedResource)) {
      this.contentReference = [];
      this.loading = false;
      await this.discoveryService()
        .getDetailService(this.getSelectedResource.docId)
        .then(res => {
          if (res?.data) {
            this.topicDetail = JSON.parse(res?.data?.serviceHtml);
            this.contentReference = (this.topicDetail.resources || [])
              .filter(item => item.docId)
              .map(item => item.docId)
              .slice(0, 15);
            if (res?.data?.bpId) {
              this.getDetailSocialBriefingPage(res?.data?.bpId);
              this.briefingPageId = true;
            } else {
              this.briefingPageId = false;
            }
            this.loading = true;
          } else {
            this.topicDetail = innitTopicDetails;
            this.contentReference = [];
            this.loading = true;
          }
        });
    }
  }

  async getDetailSocialBriefingPage(bpId) {
    if (this.tempUserKey) {
      this.tempUserKey =
        this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser')).id || this.$store.getters?.userIdentity?.id;
      this.loading = false;
      await this.briefingService()
        .getBriefingInfo(bpId, this.tempUserKey)
        .then(res => {
          if (res?.data) {
            this.detailSocialBP = res.data.body;
            this.loading = true;
          } else {
            this.topicDetail = innitTopicDetails;
            this.loading = true;
          }
        });
    }
  }

  // imgSource() {
  //   if (this.dataHeading?.data?.title_image?.content) {
  //     return this.dataHeading.data.title_image.content;
  //   } else {
  //     return '/content/images/';
  //   }
  // }

  addToResource() {
    this.updatingBookmark = true;
    const toggleBookmark = !this.getSelectedResource.isBookmarked;
    const requestPromise = toggleBookmark
      ? this.briefingService().saveUserResource(Date.now(), 'TOPIC_SUMMARY', this.getSelectedResource.originParentDocDetail)
      : this.briefingService().unSaveUserResource(Date.now(), this.getSelectedResource.docId);
    requestPromise
      .then(response => {
        this.setSelectedResource({ ...this.getSelectedResource, isBookmarked: toggleBookmark });
        this.updateTotalResources(toggleBookmark ? 1 : -1);
        this.updateAddingResources({
          ...this.getSelectedResource,
          isBookmarked: toggleBookmark,
          userProfile: {
            userKey: this.$store.getters?.userIdentity?.id,
            lastName: this.$store.getters?.userIdentity?.lastName,
            imageUrl: this.$store.getters?.userIdentity?.imageUrl,
          },
        });
      })
      .finally(() => {
        this.updatingBookmark = false;
      });
  }

  addToNewAgentBriefing() {
    if (checkIsGuestAccount(true)) return;
    const briefingResource = this.convert2ReferenceResource(this.getSelectedResource, false);
    this.setReferenceDocumentsForNewBriefing([briefingResource]);
    this.setIsCanShowCreateAgent(true);
    this.setIsCreateNewBriefingFromChat(false);
    this.setShowCreateBriefing(true);
  }

  convert2ReferenceResource(document: IResourceModel, isUpdateBriefing: boolean) {
    const briefingResource = convertToBriefingResourceReq(
      document,
      this.$store.getters.userIdentity.id,
      this.$route.name,
      this.$store.getters['briefingStore/getSelectedBriefingPage'],
      undefined,
      this.$i18n.locale,
      this.$store.getters?.userIdentity?.lastName,
      undefined,
      isUpdateBriefing
    );
    briefingResource.search_type = document?.originParentDocDetail?.search_type;
    // @ts-ignore
    briefingResource.mediaType = document?.originParentDocDetail?.media_type;
    if (
      (briefingResource.search_type[0] === 'REPORT' && briefingResource.mediaType[0] === 'REPORT') ||
      document.originParentDocDetail.doc_type === 4
    ) {
      briefingResource.originType = 'REPORT';
    } else {
      briefingResource.originType = 'DISCOVERY';
    }
    briefingResource.parentDocId = document.docId;
    briefingResource.owner_user_key =
      typeof briefingResource.owner_user_key === 'string' ? briefingResource.owner_user_key : briefingResource.owner_user_key[0];
    briefingResource['referenceDocumentIndex'] = 1;

    return briefingResource;
  }

  async printTopics() {
    await VueHtmlToPaper.print('contentToPrint', {});
  }

  downloadAsWord() {
    // @ts-ignore
    this.$refs.topicContent.downloadAsWord();
    // const elementToConvert = document.getElementById('contentToPrint');  // Your target HTML element
    //
    // html2canvas(elementToConvert).then(canvas => {
    //   // Capture canvas data if needed, here for PDF or image operations
    //   const htmlString = elementToConvert.innerHTML;  // Get the inner HTML
    //
    //   const docxBlob = htmlToDocx(htmlString, null, { orientation: 'portrait' });
    //
    //   // Create a downloadable link for the contents
    //   const link = document.createElement('a');
    //   link.href = URL.createObjectURL(docxBlob);
    //   link.download = 'document.docx';
    //   link.click();
    // });
  }

  imageStyle() {
    return {
      width: '100%',
      display: this.loading ? 'inline' : 'none',
      transition: 'all 1s',
      animation: this.loading ? 'fadeIn 2s linear' : 'none',
    };
  }

  shareTopic() {
    this.setIsShowShareTopic(true);
  }

  callHideFunction() {
    if (this.getIsHideSelectedResourceItem === false) {
      this.setIsHideSelectedResourceItem(!this.getIsHideSelectedResourceItem);
    } else {
      this.setIsHideSelectedResourceItem(true);
    }
  }

  downloadTopicPDF() {
    // @ts-ignore
    this.$refs.topicContent.downloadTopicAsPDF();
  }

  // handleHeadingSelected(headingSelected) {
  //   this.headingSelected = headingSelected;
  // }
  // handleContentReference(contentReference) {
  //   this.contentReference = contentReference;
  // }
}
